mapSiteB2b()

function mapSiteB2b() {
    const select = (element) => document.querySelector(element);
    // const selectAll = (element) => document.querySelectorAll(element);

    select('.btn_show_menu_b2b').addEventListener('click', ()=> {
        select('.item-menu-map-site_sub_b2b').classList.toggle('active');
    })

}
